import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import T from "../../components/T";
import { useContent } from "../../hooks/useContent";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../../components/ui/accordion";
import { ChevronLeft } from "lucide-react";

export default function CycleAwareness() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { SANCTUARY } = useContent();
  const items = SANCTUARY?.cycle || [];
  return (
    <AppShell>
      <div className="px-8 pt-16 pb-6" data-testid="page-cycle">
        <button onClick={() => navigate("/sanctuary")} className="flex items-center gap-1 text-sm text-foreground/55 hover:text-brand mb-2">
          <ChevronLeft className="w-4 h-4" /> {t("v11.back_to_sanctuary")}
        </button>
        <p className="font-script text-2xl text-brand">{t("v11.cycle.kicker")}</p>
        <h1 className="font-serif text-4xl leading-tight"><T i18nKey="v11.cycle.h" /></h1>
        <p className="mt-3 text-foreground/70 leading-relaxed">{t("v11.cycle.intro")}</p>
      </div>
      <div className="px-8 pb-10">
        <Accordion type="single" collapsible className="rounded-3xl bg-card border border-border px-5">
          {items.map((e, i) => (
            <AccordionItem key={i} value={`cy-${i}`} data-testid={`cy-${i}`}>
              <AccordionTrigger className="font-serif text-lg text-left">{e.title}</AccordionTrigger>
              <AccordionContent className="text-foreground/80 leading-relaxed space-y-3">
                {e.subtitle && <p className="font-serif italic text-foreground/85">{e.subtitle}</p>}
                <p>{e.body}</p>
                {Array.isArray(e.bullets) && (
                  <ul className="space-y-1">
                    {e.bullets.map((b, bi) => (
                      <li key={bi} className="flex gap-2 text-foreground/85"><span className="text-brand">·</span>{b}</li>
                    ))}
                  </ul>
                )}
                {e.closer && <p className="font-serif italic text-foreground/90 pt-1">{e.closer}</p>}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </AppShell>
  );
}
